import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule } from '../../../app/guards'

// Every signed-in user may open their approvals (ADR-018): what they see is decided per task and per
// request. Not when the company's approval workflows are off (the API refuses every /approvals route).
export const Route = createFileRoute('/_app/approvals')({
  staticData: { crumb: 'approvals' },
  beforeLoad: ({ context }) => requireModule(context.session, 'workflows'),
  component: Outlet,
})
